import {configureStore} from '@reduxjs/toolkit'

import filesReducer from './slices/files'
import eventsReducer from "./slices/events"
import openmeterReducer from "./slices/openmeter"
import {openmeterApi} from "../services/openmeter"
import cameraEventsReducer from "./slices/camera-events"
import etikettenentfernungCleaningReducer from "./slices/etikettenentfernung-cleaning"
import webUploadsReducer from "./slices/web-uploads"
import reboPipelineReducer from "./slices/rebo-pipeline"
import reboPipelineLiveReducer from "./slices/rebo-pipeline-live"

export const store = configureStore({
  reducer: {
    files: filesReducer,
    cameraEvents: cameraEventsReducer,
    etikettenentfernungCleaning: etikettenentfernungCleaningReducer,
    webUploads: webUploadsReducer,
    reboPipeline: reboPipelineReducer,
    reboPipelineLive: reboPipelineLiveReducer,
    openmeterEvents: openmeterReducer,
    [openmeterApi.reducerPath]: openmeterApi.reducer,
    events: eventsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(openmeterApi.middleware)
});

export const {dispatch} = store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
